import { Device } from "@/types/device"
import { Player } from "@/types/player"

export const useGetSearchResult = (keyword: string, items: Array<Device | Player>) => {
  return items?.filter((item) => {
    if ((item as Player).uniformNumber) {
      const result = (item as Player).uniformNumber?.toString().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    if ((item as Device).numberPlayer) {
      const result = (item as Device).numberPlayer?.toString().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    if ((item as Device).namePlayer) {
      const result = (item as Device).namePlayer?.toLowerCase().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    if ((item as Player).nickname) {
      const result = (item as Player).nickname?.toLowerCase().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    if ((item as Device).serialNumber) {
      const result = (item as Device).serialNumber?.toLowerCase().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    if ((item as Device).model) {
      const serial = `${(item as Device).model}-${(item as Device).version}-${(item as Device).number}`
      const result = serial.toLowerCase().includes(keyword.toLowerCase())
      if (result) {
        return true
      }
    }

    return false
  })
}

export const useSortPlayer = (a: Player, b: Player) => {
  const betweenUniformNumber = Number(a.uniformNumber) - Number(b.uniformNumber)
  const betweenNickname = (a.nickname as string)?.localeCompare(b.nickname as string)

  if (betweenUniformNumber !== 0) {
    return betweenUniformNumber
  }

  return betweenNickname
}

export const useSortDevice = (a: Device, b: Device) => {
  const betweenModel = a.model.localeCompare(b.model)
  const betweenVersion = a.version.localeCompare(b.version)
  const betweenNumber = a.number - b.number

  if (betweenModel !== 0) {
    return betweenModel
  }
  if (betweenVersion !== 0) {
    return betweenVersion
  }

  return betweenNumber
}

export const useGetSelectedLabel = (selected?: Record<string, unknown>) => {
  if (!selected) {
    return
  }

  if ((selected as unknown as Device).serialNumber) {
    return (selected as unknown as Device).serialNumber
  }

  if ((selected as unknown as Player).nickname) {
    return (
      (selected as unknown as Player).uniformNumber + " " + (selected as unknown as Player).nickname
    )
  }
}
